'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var buttonTypes = {
  PRIMARY: {
    label: 'Primary',
    value: 'primary'
  },
  SECONDARY: {
    label: 'Secondary',
    value: 'secondary'
  },
  LINK: {
    label: 'Link',
    value: 'link'
  }
};
var actionTypes = {
  CALL_TO_ACTION: {
    label: 'Call to Action',
    value: 'call-to-action'
  },
  CANCEL: {
    label: 'Cancel',
    value: 'cancel'
  }
};
exports.buttonTypes = buttonTypes;
exports.actionTypes = actionTypes;